// @ts-check
/**
 * Must be imported with the attribute defer="defer", when loaded to soon it doesn't have the templates loaded, we saw that in a console log, it was an empty element
 */
if (!customElements.get("ff-responsive-container")) {
  class FfResponsiveContainer extends HTMLElement {
    constructor() {
      super();
      /**
       * CSS media query which has to comply to render desktop content, otherwise mobile template would be rendered
       */
      this.mediaQuery = this.dataset.ffMediaQuery;
      this.ffRender();
    }
    async ffRender() {
      let deferredSelector;
      /**
       * If section.settings.ff_background_image_mba media query is not passed, then the desktop media will be rendered by default
       */
      if (
        this.mediaQuery == undefined ||
        window.matchMedia(this.mediaQuery).matches
      ) {
        deferredSelector = "template[data-ff-desktop]";
      } else {
        deferredSelector = "template[data-ff-mobile]";
      }
      /**
       * @type {HTMLTemplateElement | null}
       */
      const deferredTemplate =
        this.querySelector(deferredSelector) ||
        this.querySelector("template[data-ff-desktop]");
        if (deferredTemplate) {
        const deferredMedia =
          deferredTemplate.content.firstElementChild?.cloneNode(true);

        if (deferredMedia)
          this.insertAdjacentElement("afterend", deferredMedia);
        this.remove();
      }
    }
  }
  customElements.define("ff-responsive-container", FfResponsiveContainer);
}